"use client";

import "styles/error.css";

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  return (
    <div className="error">
      <div className="error-main">
        <h2 className="error-main-h">
          サイトに問題が発生しています。
          <br />
          ご不便をおかけして申し訳ありません。 <br />
          エラー内容：{error.message}
        </h2>
        <button className="error-main-btn" onClick={() => reset()}>
          再レンダリングする
        </button>
      </div>
    </div>
  );
}
